import React from 'react';
import { FeedbackCategory, FeedbackPost } from '../../services/feedback/feedbackService';

export const feedbackStatusPill = (status: FeedbackPost['status']) => {
  const map: Record<FeedbackPost['status'], { cls: string; text: string }> = {
    pending: { cls: 'rm-fb-status-pill rm-fb-status-pill--pending', text: '待处理' },
    accepted: { cls: 'rm-fb-status-pill rm-fb-status-pill--accepted', text: '已受理' },
    processing: { cls: 'rm-fb-status-pill rm-fb-status-pill--processing', text: '处理中' },
    resolved: { cls: 'rm-fb-status-pill rm-fb-status-pill--resolved', text: '已解决' },
    rejected: { cls: 'rm-fb-status-pill rm-fb-status-pill--rejected', text: '不予受理' },
  };
  const x = map[status];
  return <span className={x.cls}>{x.text}</span>;
};

export const feedbackCategoryPill = (c: FeedbackCategory) => {
  const extra: Partial<Record<FeedbackCategory, string>> = {
    建议: 'fb-cat--suggest',
    '吐槽/反馈': 'fb-cat--rant',
    问题举报: 'fb-cat--report',
    求助: 'fb-cat--help',
    投票讨论: 'fb-cat--poll',
    表扬: 'fb-cat--praise',
  };
  return <span className={`fb-cat ${extra[c] || 'fb-cat--default'}`}>{c}</span>;
};

export const feedbackFeedTabKey = (sort: string, statusFilter: string | undefined): string => {
  if (statusFilter === 'resolved') return 'resolved';
  if (statusFilter === 'pending') return 'pending';
  return sort;
};
